
import isArray from 'lodash/isArray';
import forEach from 'lodash/forEach';
import verge from 'verge';



let rtn = {};


/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
rtn.addClass = (element, classnameArr) => {

	if (!isArray(classnameArr)) {
		classnameArr = [classnameArr];
	}

	forEach(classnameArr, (c) => {
		element.classList.add(c);
	})

}


/**
 * 
 */
rtn.indexOf = (collection, element) => {
	return Array.prototype.indexOf.call(collection, element)
}


/**
 * 
 */
rtn.isMobileDevice = () => {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param q [description]
 * @return [description]
 */
rtn.getContrastYIQ = (string) => {
    const rgb = string.substring(4, string.length - 1).replace(/ /g, '').split(',');
    const yiq = ((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
};


/**
 * 
 */
rtn.getBreakpoint = () => {

	let res = {};
	res.device = {
		'phone' : 480,
		'tablet': 768,
		'desktop': 1024,
		'large': 1280
	};
	res.width = verge.viewportW();
	res.height = verge.viewportH();

	return res;


}

/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param l [description]
 * @param e [description]
 * 
 * @return [description]
 */
rtn.getStyle = function(el, style) {
	return window.getComputedStyle(el).getPropertyValue(style);
}

 
rtn.init = () => {

	//smoothScrollAnchors();

}


module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/general.js